import { ContextMenu, ContextMenuDeleteWithModelUsageItem, ContextMenuItem, Id, useHasPermission } from "@dgs/core";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { PermissionName } from "../../../shared/types/permission";
import { eventTypeService } from "../shared/api/eventTypeService";

interface Props {
	eventTypeId: Id;
	onEdit: () => void;
	onDelete: () => void;
}

export const EventTypeListContextMenu: FC<Props> = ({ eventTypeId, onEdit, onDelete }) => {
	const { t } = useTranslation();

	const showUsageAction = useCallback(
		() => eventTypeService.showUsage(eventTypeId).then((r) => r.data.data),
		[eventTypeId],
	);

	const canUpdate = useHasPermission<PermissionName>(["eventTypes.update"]);
	const canDelete = useHasPermission<PermissionName>(["eventTypes.delete"]);

	return (
		<ContextMenu displayShortcutsAs="icon" size="small">
			{canUpdate && (
				<ContextMenuItem
					action={onEdit}
					title={t("Edit event type")}
					label={t("Edit event type")}
					icon="edit"
					shortcut="primary"
				/>
			)}
			{canDelete && (
				<ContextMenuDeleteWithModelUsageItem
					label={t("Delete event type")}
					title={t("Delete event type")}
					modelName={t("Event type")}
					confirmationBody={t("Are you sure you want to delete this event type?")}
					showUsageAction={showUsageAction}
					deleteAction={onDelete}
				/>
			)}
		</ContextMenu>
	);
};
